export default {
  // Вход
  login: {
    lang: 'Язык',
    systemname: 'Вход',
    username: 'Пользователь',
    username_label: 'Введите имя пользователя',
    pwd: 'Пароль',
    pwd_label: 'Введите пароль',
    pwd_info: 'Введите корректный пароль',
    success_msg: 'Вход выполнен',
    error_name: 'Неверный пароль',
    error_res: 'Не соответствует требованиям входа',
    login: 'Войти',
  },
  aside: {
    systemname: 'Панель',
    quit: 'Выйти',
    deviceControl: 'Управление',
    basicSetting: 'Настройки',
    workerSetting: 'Персонал',
    deviceMonitoring: 'Мониторинг',
    recordManagement: 'Журналы',
    securityManagement: 'ключами',
    tips: 'Подсказка',
    tips_msg: 'Выйти из системы?',
  },
  control: {
    remoteControl: 'Удалённое',
    restart: 'Перезапуск',
    clickToRestart: 'Нажмите для перезапуска',
    restartConfirm: 'Подтвердить перезапуск?',
    restartSuccess: 'Перезапуск успешен',
    restartFailed: 'Перезапуск неудачен',
    remoteOpen: 'Удалённое открытие',
    clickToOpen: 'Нажмите для открытия',
    openConfirm: 'Подтвердить удалённое открытие?',
    remoteOpenSuccess: 'Открыто успешно',
    remoteOpenFailed: 'Открыть не удалось',
    reset: 'Сброс устройства',
    clickToReset: 'Нажмите для сброса',
    resetConfirm: 'Подтвердить сброс?',
    resetSuccess: 'Сброс успешен',
    resetFailed: 'Сброс неудачен',
    firmwareUpgrade: 'Обновление прошивки',
    upgradeConfig: 'Настройки обновления',
    firmwareUrl: 'URL прошивки',
    md5Checksum: 'md5',
    startUpgrade: 'Начать обновление',
    urlRequired: 'URL обязателен',
    md5Required: 'md5 обязателен',
    urlInvalid: 'Введите корректный URL',
    md5Invalid: 'Введите корректный md5',
    upgradeConfirm: 'Подтвердить обновление?',
    upgradeSuccess: 'Обновление успешно',
    clearFile: "Очистить файл",
    uploading: 'Загрузка...',
    uploadAndUpgrade: 'Загрузить и обновить',
    restartTips: 'Безопасный перезапуск, данные не потеряются',
    restarting: 'Перезапуск...',
    remoteTips: 'Удалённый контроль доступа',
    opening: 'Открывается...',
    resetTips: 'Сброс к заводским, данные удалятся',
    reseting: 'Сбрасывается...',
    urlUpgrade: 'Обновление по URL',
    fileUpgrade: 'Обновление файлом',
    uploadFile: 'Кликните для загрузки прошивки',
    formatFile: 'Поддержка .zip или .dpk, до 20MB',
    fileName: 'Имя файла',
    size: 'Размер',
  },
  config: {
    second: 'с',
    millisecond: 'мс',
    min: 'минут',
    notsave: 'Не сохранять',
    save: 'Сохранить',
    noVoice: 'Без голоса',
    no: 'Нет',
    yes: 'Да',
    basicConfiguration: 'Базовая конфигурация',
    displaySettings: 'Настройки экрана',
    informationDisplay: 'Отображение инфо',
    audioSettings: 'Аудио',
    languageAndThemes: 'Язык и тема',
    autoAdjustScreenBrightness: 'Автояркость',
    screenBrightness: 'Яркость экрана',
    autoTurnOffScreen: 'Автовыключение экрана',
    autoTurnOffScreenTime: 'Время отключения',
    autoScreenSaver: 'Авто заставка',
    autoScreenSaverTime: 'Время заставки',
    displayDeviceSn: 'Показать SN',
    displayIp: 'Показать IP',
    displayIdentityCard: 'Показать облачный сертификат',
    volume: 'Громкость',
    language: 'Язык',
    displayCode: "Показать код мини-приложения",
    themeMode: "Тема",
    cn: 'Китайский',
    en: 'Английский',
    es: 'Испанский',
    fr: 'Французский',
    de: 'Немецкий',
    ru: 'Русский',
    ar: 'Арабский',
    pt: 'Порт.',
    ko: 'Корейский',
    standardMode: 'Стандартный режим',
    simpleMode: 'Простой режим',
    firstLogin: 'Первый вход',
    backlight: 'Подсветка',
    brightness: 'Белая подсветка',
    nirBrightness: 'ИК-подсветка',
    never: 'Никогда',
    min1: '1 минута',
    min2: '2 минуты',
    min3: '3 минуты',
    min4: '4 минуты',
    min5: '5 минут',
    networkConfiguration: 'Сеть',
    otherConfiguration: 'Прочее',
    ipConfiguration: 'IP настройки',
    devicePassword: 'Пароль устройства',
    protocolPassword: 'Пароль протокола',
    networkType: 'Тип сети',
    ethernet: 'Ethernet',
    wifiName: 'Wi‑Fi',
    wifiPassword: 'Пароль Wi‑Fi',
    dhcpModeSelection: 'Режим DHCP',
    dhcpMode: 'Авто',
    customNetworkConfiguration: 'Ручной',
    ipAddress: 'IP-адрес',
    gateway: 'Шлюз',
    subnetMask: 'Маска подсети',
    dnsServer: 'DNS сервер',
    mac: 'MAC',
    mqttRelatedConfiguration: 'MQTT',
    mqttConnectionInformation: 'Подключение MQTT',
    sessionConfiguration: 'Сессия',
    serverAddress: 'Адрес сервера',
    clientID: 'ID клиента',
    userName: 'Имя пользователя',
    userPassword: 'Пароль',
    topicPrefix: 'Префикс топика',
    onlineChecking: 'Онлайн-проверка',
    onlineCheckingTimeout: 'Тайм-аут',
    cleanSession: 'Очистить сессию',
    clientIdSuffix: 'Суффикс ID',
    willTopic: 'Will-топик',
    enterpriseWechat:'Режим Enterprise WeChat не действует',
    faceRelatedConfiguration: 'Настройки лица',
    functionalInformation: 'Функция',
    prompt: 'Подсказка',
    faceSimilarityThreshold: 'Порог схожести',
    livenessDetectionFunction: 'Проверка живости',
    livenessDetectionThreshold: 'Порог живости',
    infraredImageDisplay: "Показ ИК-изображения",
    maskRecognition: "Распознавание маски",
    strangerVoice: "Голос незнакомца",
    voiceMode: "Режим голоса",
    voiceModeDate: 'Пользовательское приветствие',
    imageSaveType: "Тип сохранения",
    saveStrangerImage: "Сохранять лицо незнакомца",
    fullView: "Панорама",
    face: "Лицо",
    broadcastPleaseRegisterFirst: 'Проигрывать "Сначала зарегистрируйтесь"',
    broadcastHelloStranger: 'Проигрывать "Незнакомец"',
    broadcastName: 'Проигрывать имя',
    broadcastGreeting: 'Проигрывать своё приветствие',
    greeting: 'Приветствие',
    broadcastWelcome: 'Проигрывать "Добро пожаловать"',
    recognitionSwitch: 'Переключатель повторной проверки',
    systemRelatedConfiguration: 'Система',
    functionSwitch: 'Переключатели',
    cardSwipingSwitch: 'Карта',
    passwordSwitch: 'Пароль',
    strangerImage: 'Фото незнакомца',
    cloudCertificateSwitch: 'Облачный сертификат',
    physicalCardNumber: 'Номер карты',
    cloudCertificateAcquisition: 'Получение облачного сертификата',
    heartbeatConfig: 'Heartbeat',
    heartbeatSwitch: 'Вкл./выкл. heartbeat',
    heartRateInterval: 'Интервал',
    heartbeatTopic: 'Топик heartbeat',
    heartbeatContent: 'Содержимое',
    basicInformation: 'Базовая информация',
    deviceMac: 'MAC',
    uuid: 'UUID',
    sn: 'SN',
    model: 'Модель',
    version: "Версия",
    appVersion: "Версия прошивки",
    releaseTime: "Время обновления",
    totaldisk: 'Общая площадь',
    freedisk: 'Оставшееся пространство',
    passageConfiguration: 'Проход',
    functionConfiguration: 'Функции',
    numberOfPassageRecords: 'Макс. записей прохода',
    durationOfRelayOpening: 'Время реле',
    alarmSwitch: 'Сигнализация',
    fireAlarmSwitch: 'Пожарная сигнализация',
    fireAlarmStatus: 'Статус пожара',
    normal: 'Норма',
    warning: 'Предупреждение',
    tamperSwitch: 'Тамперовка',
    uploadToCloudSwitch: 'Переключатель загрузки лица',
    clockConfiguration: 'Часы',
    timeSynchronizationSwitch: 'Синхронизация времени',
    timeSynchronizationServerIP: 'Сервер времени',
    timedSynchronizationTime: 'Время синхронизации',
    timeZone: 'Часовой пояс',
    setDeviceTime: 'Установить время',
    restartAfterSetting: 'После установки устройство перезапустится',
    cloudCertificateActivation: 'Активация сертификата',
    activationKey: 'Ключ активации',
    cloudTips1: 'Введите ключ без пробелов',
    cloudTips2: 'После активации подключится к облачному сервису',
    confirmActivation: 'Подтвердить активацию',
    activationInProgress: 'Активация...',
    activationFailed: 'Сбой активации',
    activationSuccessful: 'Активация успешна',
    passwordModification: 'Изменение пароля',
    password: 'Пароль',
    oldPassword: 'Старый пароль',
    newPassword: 'Новый пароль',
    confirmPassword: 'Подтвердите пароль',
    passwordRule: 'Рекомендации по паролю',
    passwordLength: 'Длина ≥6',
    cannotBeTheSame: 'Все символы не могут быть одинаковыми',
    cannotOrder: 'Не менее 3 подряд цифр/букв',
    cannotWeakPassword: 'Не использовать слабые пароли',
    submit: 'Отправить',
    saveConfig: 'Сохранить',
    msg_please_enter: 'Введите содержание',
    msg_inputPassword: 'Введите пароль',
    msg_oldPasswordError: 'Старый пароль неверен',
    msg_password_mismatch: 'Пароли не совпадают',
    msg_password_min_length: 'Минимум 6 символов',
    msg_is_weak_password: 'Слабый пароль, смените',
    msg_pswChangeSuccessAndLogin: 'Пароль изменён, войдите снова',
    msg_pswChangeSuccess: 'Пароль изменён',
    msg_pswChangeFail: 'Не удалось изменить пароль',
    msg_saveSuccess: 'Успешно сохранено',
    msg_saveFail: 'Сохранение не удалось',
    msg_formFilled: 'Проверьте форму',
    msg_number_0_23: 'Только 0-23',
    msg_number_0_24: 'Только 0-24',
    msg_noChange: 'Нет изменений конфигурации для сохранения',
    resourceConfiguration: 'Настройки ресурсов',
    backgroundImage: 'Фоновое изображение',
    selectImage: 'Выбрать изображение',
    uploadBackground: 'Загрузить фон',
    uploading: 'Загрузка...',
    backgroundUploadTip: 'Загрузите изображение в формате PNG с разрешением {n} пикселей, изображение будет преобразовано в Base64 и загружено на устройство',
    backgroundResolutionMismatch: 'Разрешение изображения должно быть {n}',
    backgroundRequired: 'Выберите фоновое изображение',
    backgroundImageOnlyPNG: 'Только PNG',
    backgroundSizeLimit: 'Размер ≤ 5MB',
    backgroundParseFailed: 'Не удалось прочитать изображение',
    backgroundImageSelected: 'Изображение выбрано',
    backgroundSuccess: 'Фон загружен',
    backgroundFailed: 'Ошибка загрузки фона',
    scanSettings: 'Настройки сканирования',
    scanSwitch: 'Переключатель сканирования',
    scanInterval: 'Интервал сканирования',
  },
  person: {
    idCard: 'Номер удостоверения',
    userType: 'Тип пользователя',
    administrator: 'Администратор',
    userId: 'ID',
    user: 'Пользователь',
    voucher: 'Удостоверение',
    permission: 'Разрешение',
    addUser: 'Добавить пользователя',
    name: 'Имя',
    editUser: 'Редактировать',
    placeholderUserId: 'Введите ID',
    placeholderName: 'Введите имя',
    userNotExist: 'Пользователь не найден',
    oneClickClear: 'Очистить все',
    clearTips: 'Будут удалены все данные, продолжить?',
    clearSuccess: 'Успешно очищено',
    clearFailed: 'Не удалось очистить',
  },
  voucher: {
    password: 'Пароль',
    card: 'Карта',
    face: 'Лицо',
    finger: 'Отпечаток',
    code: 'Код',
    codeType: 'Тип кода',
    passthroughCode: 'Сквозной код',
    staticCode: 'Статический код',
    dynamicCode: 'Динамический код',
    placeholderCode: 'Пожалуйста, введите код сертификата',
    placeholderPwd: 'Введите пароль',
    placeholderCard: 'Введите карту',
    validPassword: 'Введите 6 цифр',
    validCard: 'Введите 8 цифр или букв',
    photoRegistration: 'Регистрация фото',
    featureValueRegistration: 'Регистрация признаков',
    fingerRegistration: 'Регистрация отпечатка',
    fingerFeatureRegistration: 'Регистрация по значению признака',
    fingerInput: 'Приложите палец к сканеру отпечатков',
    fingerRemainingTime: 'Оставшееся время',
    fingerInputting: 'Идёт ввод...',
    startFingerInput: 'Начать ввод отпечатка',
    fingerInputTips: 'Введите значение признака отпечатка',
    fingerWaitInput: 'Ожидание ввода',
    fingerInputNow: 'Идёт ввод отпечатка...',
    fingerInputSuccess: 'Ввод успешен',
    fingerInputFailed: 'Не удалось запустить ввод отпечатка',
    fingerReTry: 'Ошибка ввода отпечатка, попробуйте ещё раз',
    fingerFilled: 'Ввод отпечатка успешен, значение признака заполнено автоматически',
    fingerFailed: 'Ошибка ввода отпечатка',
    fingerTimeout: 'Время вышло',
    fingerInputTimeout: 'Время ввода отпечатка истекло, попробуйте ещё раз',
    fingerError: 'Ввод не выполнен',
    fingerInputError: 'Ошибка ввода отпечатка, попробуйте ещё раз',
    fingerInputed: 'Отпечаток уже зарегистрирован',
    fingerReInput: 'Повторно ввести отпечаток',
  },
  permission: {
    deletePermission: 'Удалить разрешение',
    addPermission: 'Добавить разрешение',
    permissionId: 'ID разрешения',
    userId: 'ID пользователя',
    timeRange: 'Временной диапазон',
    extra: 'Дополнительно',
    effectiveType: 'Тип действия',
    effectiveTime: 'Время действия',
    effectiveWeek: 'Неделя действия',
    timePeriod: 'Период',
    addTimePeriod: 'Добавить период',
    modify_previous_time: 'Сначала измените предыдущий период',
    cannot_be_earlier: 'Конец не может быть раньше начала',
    times_cannot_overlap: 'Время не должно пересекаться',
    choose_time_range: 'Выберите диапазон',
    unlimitedMode: 'Без ограничений',
    usualMode: 'Обычный режим',
    dailyMode: 'Ежедневный',
    weeklyRepetitionMode: 'Еженедельный',
    time_range: 'Диапазон времени',
  },
  common: {
    startDate: 'Дата начала',
    endDate: 'Дата окончания',
    to: 'до',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    close: 'Закрыть',
    delete: 'Удалить',
    edit: 'Изменить',
    batchDelete: 'Пакетное удаление',
    startTime: 'Время начала',
    endTime: 'Время окончания',
    monday: 'Понедельник',
    tuseday: 'Вторник',
    wednesday: 'Среда',
    thursday: 'Четверг',
    friday: 'Пятница',
    saterday: 'Суббота',
    sunday: 'Воскресенье',
    placeholder: 'Пожалуйста, введите',
    placeholderSelect: 'Пожалуйста, выберите',
    closeTips: 'Подтвердить закрытие?',
    deleteTips: 'Подтвердить удаление?',
    deleteSuccess: 'Удалено успешно',
    addSuccess: 'Успешно добавлено',
    editSuccess: 'Успешно изменено',
    saveSuccess: 'Сохранено',
    tips: 'Подсказка',
    operation: 'Операция',
    query: 'Запрос',
    reset: 'Сброс',
    noData: 'Нет данных',
    export: 'Экспорт',
    success: 'Успех',
    failure: 'Неудача',
    incorrectFormat: 'Неверный формат',
    integerFormat: 'Целое число ≥0',
    positiveIntegerFormat: 'Целое число >0',
    noDataSaved: 'Нет данных для сохранения',
    chinese: 'Китайский',
    english: 'Английский',
    spanish: 'Испанский',
    french: 'Французский',
    german: 'Немецкий',
    russian: 'Русский',
    arabic: 'Арабский',
    portuguese: 'Португальский',
    korean: 'Корейский',
    detail: 'Подробности',
    clearTips: 'Подтвердить очистку?',
    clearSuccess: 'Успешно очищено',
  },
  log: {
    accessMethod: 'Способ доступа',
    passingTime: 'Время прохода',
    accessPass: 'Удостоверение',
    accessResult: 'Результат',
    accessPhoto: 'Фото',
    viewPhotos: 'Просмотр фото'
  },
  error: {
    networkError: 'Сбой сети, проверьте подключение',
    timeout: 'Тайм-аут, попробуйте снова',
    serverError: 'Внутренняя ошибка сервера',
    notFound: 'Ресурс не найден',
    unauthorized: 'Не авторизован, войдите снова',
    noResponse: 'Нет ответа сервера',
    unknownError: 'Ошибка запроса, код:',
    requestFailed: 'Запрос не выполнен'
  },
  security: {
    keyId: 'ID ключа',
    keyType: 'Тип ключа',
    keyEncoding: 'Кодировка ключа',
    keyValue: 'Значение ключа',
    startTime: 'Время начала',
    expirationTime: 'Время истечения',
    newKey: 'Добавить ключ',
    clearKey: 'Очистить ключ',
    validTime: 'Срок действия',
  }
}
